(() => {
  'use strict';

  const pageType = document.documentElement.dataset.template || document.body.dataset.template || 'unknown';
  const dispatch = (detail) => {
    document.dispatchEvent(new CustomEvent('chubbies:cro', {
      detail: {
        page_type: pageType,
        ...detail,
      },
    }));
  };

  const visibleSections = new WeakSet();
  const observeSection = (section) => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting || visibleSections.has(entry.target)) continue;
        visibleSections.add(entry.target);
        dispatch({
          event: 'section_view',
          section: entry.target.dataset.croSection,
          variant_key: entry.target.dataset.croVariant || undefined,
        });
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.35 });
    observer.observe(section);
  };

  document.querySelectorAll('[data-cro-section]').forEach(observeSection);

  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-cro-action]');
    if (!action) return;
    const section = action.closest('[data-cro-section]');
    dispatch({
      event: 'cta_click',
      action: action.dataset.croAction,
      section: section?.dataset.croSection,
      variant_key: section?.dataset.croVariant || undefined,
      destination: action.getAttribute('href') || undefined,
    });
  });
})();
